// 新闻中心（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <ul class="newsUl">
        <li class="newsList" v-for="(item,index) in newList" :key="index">
          <div class="left" id="leftImg" @click="detial(item.newid)" v-html="item.introduce"></div>
          <div class="right">
            <h3 @click="detial(item.newid)">{{ item.title }}</h3>
            <p class="time">发布日期：{{ item.pushtime | dateformat('YYYY-MM-DD') }}</p>
          </div>
        </li>
      </ul>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {
      newList: [],
    };
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mNews"); //移动端跳转路由
    } else {
      this.$router.replace("/news"); //Pc端跳转路由
    }
    this.getList();
  },
  methods: {
    // 请求新闻列表
    getList() {
      const _this = this;
      this.$axios
        .post("http://101.200.166.238:9006/pushnews/queryAll")
        .then((response) => {
          // console.log("111", response);
          _this.newList = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 点击跳转
    detial(index) {
      // console.log('2222',index);
      this.$router.push({
        path: "/mNewsDetail",
        query: {
          newid: index,
        },
      });
    },

    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/新闻.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .newsUl {
      margin: 0;
      padding: 0;
      margin-top: 0.6rem;
      min-height: 8rem;
      .newsList {
        height: 5.13rem;
        border-bottom: 0.03rem dashed #1f89ec;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.71rem;
        padding-top: 0.6rem;
        box-sizing: border-box;
        .left {
          width: 6rem;
          height: 3.82rem;
          overflow: hidden;
          float: left;
          margin-right: 0.8rem;
          img {
            width: 6rem;
            height: 3.82rem;
          }
        }
        .left:hover {
          cursor: pointer;
        }
        .right {
          width: 12.8rem;
          margin-top: -1rem;
          h3 {
            opacity: 1;
            font-size: 0.7rem;
            font-family: Microsoft YaHei Regular,
              Microsoft YaHei Regular-Regular;
            font-weight: 400;
            text-align: justifyLeft;
            color: #000000;
            line-height: 1.3rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          h3:hover {
            cursor: pointer;
          }
          .time {
            opacity: 1;
            font-size: 0.5rem;
            font-family: Microsoft YaHei Regular,
              Microsoft YaHei Regular-Regular;
            font-weight: 400;
            text-align: justifyLeft;
            color: #999999;
            margin-top: 2.1rem;
          }
        }
      }
    }
  }
}
</style>
